import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../shared/loading/loading.component';
import { ToastrService } from 'ngx-toastr';
import { RoleService } from '../../../../core/services/role.service';
import { AppActionCheck } from '../../../../core/utils/app-action-check';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { DeliveryService } from '../../../../core/services/delivery.service';
import { PricingService } from '../../../../core/services/pricing.service';
import { DeliveryPlanService } from '../../../../core/services/delivery-plan.service';
import { CountryService } from '../../../../core/services/country.service';
import { DeliverService } from '../../../../core/services/deliver.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { StatusComponent } from '../../component/status/status.component';

@Component({
  selector: 'app-delivery',
  standalone: true,
  imports: [
     CommonModule,
            FormsModule,
            NgbModule,
            NgxPaginationModule,
            LoadingComponent,
            SampleSearchPipe,
            NgSelectModule,
            StatusComponent
  ],
  templateUrl: './delivery.component.html',
  styleUrl: './delivery.component.css'
})
export class DeliveryComponent {
 buttonsPermission :any|undefined;
  structures:any[] =[]
  roles:any[] =[]
  data:any[] =[]
  dataTarifs:any[] =[]
  dataPlans:any[] =[]
  countries:any[] =[]
  delivers:any[] =[]
  selectedWindow:any
  selected_data:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  tag="Livraisons"
  permissionName=""
    search_text=""
role:any
  user:any
  loading2=false
pg={
    pageSize:10,
    p:0,
    total:0
  }

  pg2={
    pageSize:10,
    p:0,
    total:0
  }
  pg3={
    pageSize:10,
    p:0,
    total:0
  }


  constructor(
    private deliveryService:DeliveryService,
    private dpService:DeliveryPlanService,
    private pricingService:PricingService,
    private deliverService:DeliverService,
    private countryService:CountryService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
    this.getActions()
  }

  init(){
    this.getAll()
    this.getAll2()
    this.getAll3()
    this.getCountries()
    this.getDelivers()
  
  }

 

  getAll(){
    this.loading2=true

    this.deliveryService.getAll().subscribe((res:any)=>{
      this.data=res.data 
this.pg.pageSize=10
 this.pg.p=0
 this.pg.total=res.data.length
      this.modalService.dismissAll()
      this.loading2=false

    },
    (err:any)=>{
      this.loading2=false
      AppErrorShow.showError("Gestion des rôles",err)

    })
  }
  getAll2(){
    this.loading2=true

    this.dpService.getAll().subscribe((res:any)=>{
      this.dataPlans=res.data 
this.pg2.pageSize=10
 this.pg2.p=0
 this.pg2.total=res.data.length
      this.modalService.dismissAll()
      this.loading2=false

    },
    (err:any)=>{
      this.loading2=false
      AppErrorShow.showError("Gestion des rôles",err)

    })
  }
  getAll3(){
    this.loading2=true

    this.pricingService.getAll().subscribe((res:any)=>{
      this.dataTarifs=res.data 
this.pg3.pageSize=10
 this.pg3.p=0
 this.pg.total=res.data.length
      this.modalService.dismissAll()
      this.loading2=false

    },
    (err:any)=>{
      this.loading2=false
      AppErrorShow.showError("Gestion des rôles",err)

    })
  }

  getCountries(){
    this.countryService.getAll().subscribe((res:any)=>{
      this.countries=res.data
    },
    (err:any)=>{

    })
  }

  getDelivers(){
    this.deliverService.getAll().subscribe((res:any)=>{
      this.delivers=res.data
    },
    (err:any)=>{

    })
  }


  //Action for delivery plan
  store(value:any){
    this.loading=true
    value.order_id=this.selected_data.order_id
    this.deliveryService.assignDeliver(value).subscribe((res:any)=>{
      this.loading=false
      this.toastrService.success(res.message)
      this.getAll2()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
  update(value:any){
    this.loading=true
    value.order_id=this.selected_data.order_id
    this.deliveryService.assignDeliver(value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll2()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.dpService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll2()
    },
    (err:any)=>{
      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
})
  }
  //Action for delivery plan
  store2(value:any){
    this.loading=true
    this.dpService.store(value).subscribe((res:any)=>{
      this.loading=false
      this.toastrService.success(res.message)
      this.getAll2()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
  update2(value:any){
    this.loading=true

    this.dpService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll2()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
  delete2(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.dpService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll2()
    },
    (err:any)=>{
      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
})
  }


  //Action for pricing
   store3(value:any){
    value['type']="delivery"
    this.loading=true
    this.pricingService.store(value).subscribe((res:any)=>{
      this.loading=false
      this.toastrService.success(res.message)
      this.getAll3()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
  update3(value:any){
    this.loading=true
    value['type']="delivery"
    this.pricingService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll3()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
  delete3(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.pricingService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll3()
    },
    (err:any)=>{
      console.log(err)
      AppErrorShow.showError("Gestion des rôles",err)
    })
  }
})
  }


  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }


  getActions(){
    this.buttonsPermission = {
      show:AppActionCheck.check(this.tag,'Consulter'),
      add:AppActionCheck.check(this.tag,'Ajouter'),
      edit:AppActionCheck.check(this.tag,'Editer'),
      delete:AppActionCheck.check(this.tag,'Supprimer'),
      status:AppActionCheck.check(this.tag,'Mettre un statut'),
      print:AppActionCheck.check(this.tag,'Imprimer/Télécharger'),
      transUp:AppActionCheck.check(this.tag,'Transmettre'),
      transDown:AppActionCheck.check(this.tag,'Affecter'),
      sign:AppActionCheck.check(this.tag,'Signer'),
      viewer:AppActionCheck.check(this.tag,'Visualiser Fichier'),
      return:AppActionCheck.check(this.tag,'Retouner pour correction')
    };
  }


  getPage(event:any){
    this.pg.p=event
  }
  getPage2(event:any){
    this.pg2.p=event
  }
  getPage3(event:any){
    this.pg3.p=event
  }
}
